import {
  FieldDef,
  formatDate,
  formatDateTime,
  formatDollarAmount,
} from "@synota-io/synota-shared-ui";
import { IAdhocInvoice } from "../../../../api/hooks/useAdhocInvoices";
import { AdhocStatusCell } from "./AdhocStatusCell";

export const adhocFields: FieldDef<IAdhocInvoice>[] = [
  {
    field: "shared_uuid",
    headerName: "ID",
    minWidth: 120,
    displayTags: [],
    type: "string",
  },
  {
    field: "ad_hoc_title",
    headerName: "Title",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "ad_hoc_amount",
    headerName: "Ad Hoc Amount",
    minWidth: 160,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "created_date",
    headerName: "Created (UTC)",
    minWidth: 170,
    type: "string",
    valueFormatter: (value) => formatDateTime(value),
  },
  {
    field: "start_date",
    headerName: "Start Date",
    minWidth: 130,
    type: "string",
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "end_date",
    headerName: "End Date",
    minWidth: 130,
    type: "string",
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "ad_hoc_number",
    headerName: "Ad Hoc Number",
    minWidth: 140,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "amount_paid",
    headerName: "Amount Paid",
    minWidth: 140,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "amount_pending",
    headerName: "Amount Pending",
    minWidth: 160,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 155,
    flex: 1,
    type: "string",
    renderCell: ({ row }) => <AdhocStatusCell invoice={row} />,
  },
];
